import type React from 'react';
import { externalVideoUrl } from './externalVideoUrl';
import { clipboardImageFile } from './tableImport';

/** Pasted-while-focused handler shared by the image zone: an image wins over a video link. */
export function handleImageZonePaste(
  event: React.ClipboardEvent,
  onFile: (file: File) => void,
  onVideoUrl?: (url: string) => void,
) {
  const file = clipboardImageFile(event.clipboardData);
  if (file) {
    event.preventDefault();
    onFile(file);
    return;
  }
  const videoUrl = onVideoUrl && externalVideoUrl(event.clipboardData?.getData('text/plain'));
  if (!videoUrl) return;
  event.preventDefault();
  onVideoUrl?.(videoUrl);
}
